/**
 * Client mirror of the server's username format + profanity validation
 * (server/src/helpers/username.helper.js). Lets the UI give instant feedback and disable
 * "Check" for obviously-bad input before hitting the availability endpoint. The server
 * remains the source of truth (it also enforces uniqueness).
 *
 * See specs/onboarding-questionnaire/spec.md (§9 T-1).
 */

import { containsProfanity } from '../../helpers/profanity.helper';

export const USERNAME_MIN = 3;
export const USERNAME_MAX = 20;
export const USERNAME_PATTERN = /^[A-Za-z0-9_]+$/;

export type UsernameInvalidReason = 'invalid' | 'profanity';

export interface UsernameCandidateResult {
  valid: boolean;
  reason: UsernameInvalidReason | null;
  normalized: string;
}

export function validateUsernameCandidate(value: string): UsernameCandidateResult {
  const normalized = (value ?? '').trim();
  if (
    normalized.length < USERNAME_MIN
    || normalized.length > USERNAME_MAX
    || !USERNAME_PATTERN.test(normalized)
  ) {
    return { valid: false, reason: 'invalid', normalized };
  }
  if (containsProfanity(normalized)) {
    return { valid: false, reason: 'profanity', normalized };
  }
  return { valid: true, reason: null, normalized };
}
